import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";

//import 'bootstrap/dist/css/bootstrap.css';
import "./Assets/scss/Theme.scss";
import 'bootstrap-daterangepicker/daterangepicker.css';
// import { GoogleOAuthProvider } from '@react-oauth/google';
// import AuthProvider from './auth0Provider';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <GoogleOAuthProvider clientId="983053546429-o1q2t7c4vntkg738e3poaqsless7b9q1.apps.googleusercontent.com"> */}
      {/* <GoogleOAuthProvider clientId="Bn3UGay7jdpTNdztKZMxQgE7BHyL9aX3"> */}
      <App />
      {/* </GoogleOAuthProvider> */}
    </PersistGate>
  </Provider>
);
